export default __webpack_public_path__ + "locales/sq-AL/BackupCodesDialog.json?hash=faf6db22f631e1b1ae854fd1280ee8a9";